import React, { Component } from "react";
import { Row, Col } from "reactstrap";

//import en from "date-fns/locale/en"
//import fr from "date-fns/locale/fr"
import styled from "styled-components";

import {
  Button,
  DatePicker,
  PhoneInput,
  TextInput,
  RadioSection,
  NumberInput,
  TextInputMultiline,
  Dropdownlist,
  MaskedInput,
  CheckButton,
  Popover
} from "ia-react-ui-components";


const ErrorMessage = styled.p`
  color: red;
`;

const getKey = (obj, value) => {
  Object.keys(obj).find(key => obj[key] === value);
}

export class GenerateInputArea extends Component {
  constructor(props) {
    super(props);
  }

  // Helper function to get access to the question by name.
  getQuestionByName = name => {
    var question = null;
    this.props.questions.forEach(x => {
   
      if (x.name === name) {
        question = x;
      }
    });
    return question;
  };

  //////////////////////////////////////
  // Handle Inputs
  //
  // Note that the iA component react library passes only value and name

  handleInputChange = (value, name) => {
    //alert(name);    alert(value);
    if (value !== undefined) {
      var question = this.getQuestionByName(name);

      // Update the main master collection.
      question.value = value;
      this.setState({ questions: this.props.questions });
    }
  };

  handleInputChangeHide = (value, name) => {
   //alert(name);    alert(value);
    var question = this.getQuestionByName(name);
    question.value = value;

    let options = this.props.lang === "e" ? question.options_e: question.options_f;
    question.key = getKey(options, value);

    this.props.hideHandler(value, name);
    this.setState({ questions: this.props.questions });
  };

  //iA Dropdown component passes value as value.key
  handleInputChangeDropdown = (value, name) => {
    if (value !== undefined) {
      //alert(name);    //alert(value.key);
      var question = this.getQuestionByName(name);
      question.value = value.key;

      this.setState({ questions: this.props.questions });
    }
  };

  //Assumption is the question name is 3 characters e.g. q8a
  //Must be done this way as component only passes two parameters
  handleInputChangeCheckboxHide = (value, name) => {
    var questionName = name.substring(0, 3);
    var option = name.substring(3);

    var question = this.getQuestionByName(questionName);
    question.value[option] = value;

    this.props.hideHandler(value, name);
    this.setState({ questions: this.props.questions });
  };

  //single checkbox
  handleInputChangeCheckbox = (value, name) => {
    var question = this.getQuestionByName(name);
    question.value[0] = value;

    this.props.hideHandler(value, name);
    this.setState({ questions: this.props.questions });
  };

  handleInputButton = (value, name) => {
    this.props.hideHandler(value);
  };


  //////////////////////////////////////
  // Create Inputs
  //
  generateInput = questionName => {
    var q = this.getQuestionByName(questionName);

    if (q.question_type === "date") {     
      return (
        <Col sm={q.cols} key={q.name}>
          <label>
            {this.props.lang === "en" ? q.question_e : q.question_f}
          </label>
          <DatePicker
              name={q.name}
              defaultValue={q.value}
              onChange={this.handleInputChange}
          />
          <ErrorMessage>{!q.valid ? q.errorMessage : ""}</ErrorMessage>
        </Col>
      );
    }
   
    if (q.question_type === "radioHide") {
      return (
        <Col sm={q.cols} key={q.name}>
          <label>
            {this.props.lang === "en" ? q.question_e : q.question_f}
          </label>
          <RadioSection
            name={q.name}
            options={this.props.lang === "en" ? q.options_e : q.options_f}
            selected={q.value}
            onChange={this.handleInputChangeHide}
          />
          <ErrorMessage>{!q.valid ? q.errorMessage : ""}</ErrorMessage>
        </Col>
      );
    }
    if (q.question_type === "phone") {
      return (
        // alert("create phone: " + q.errorMessage)
        <Col sm={q.cols} key={q.name}>
          <label>
            {this.props.lang === "en" ? q.question_e : q.question_f}
          </label>
          <PhoneInput
            name={q.name}
            value={q.value}
            onChange={this.handleInputChange}
          />
          <ErrorMessage>{!q.valid ? q.errorMessage : ""}</ErrorMessage>
        </Col>
      );
    }
    //masked input
    if (q.question_type === "mask") {
      return (
        <Col sm={q.cols} key={q.name}>
          <label>
            {this.props.lang === "en" ? q.question_e : q.question_f}{" "}
          </label>
          <MaskedInput
            name={q.name}
            value={q.value}
            onChange={this.handleInputChange}
            mask={q.mask}
          />
          <ErrorMessage>{!q.valid ? q.errorMessage : ""}</ErrorMessage>
        </Col>
      );
    }
    if (q.question_type === "text") {
      return (
        <Col sm={q.cols} key={q.name}>
          <label>
            {this.props.lang === "en" ? q.question_e : q.question_f}
            {q.tooltip_e !== undefined ? (
              <Popover
                title={this.props.lang === "en" ? "Hint" : "Suggestion"}
                content={this.props.lang === "en" ? q.tooltip_e : q.tooltip_f}
              />
            ) : null}
          </label>
          <TextInput
            name={q.name}
            //type={q.question_type}
            value={q.value}
            onChange={this.handleInputChange}
            maxLength={q.maxLength}
          />
          <ErrorMessage>{!q.valid ? q.errorMessage : ""}</ErrorMessage>
        </Col>
      );
    }
    if (q.question_type === "multiLineText") {
      return (
        <Col sm={q.cols} key={q.name}>
          <label>
            {this.props.lang === "en" ? q.question_e : q.question_f}
            {q.tooltip_e !== undefined ? (
              <Popover
                title={this.props.lang === "en" ? "Hint" : "Suggestion"}
                content={this.props.lang === "en" ? q.tooltip_e : q.tooltip_f}
              />
            ) : null}
          </label>
          <TextInputMultiline
            name={q.name}
            value={q.value}
            onChange={this.handleInputChange}
            maxLength={q.maxLength}
          />
          <ErrorMessage>{!q.valid ? q.errorMessage : ""}</ErrorMessage>
        </Col>
      );
    } //for currency
    if (q.question_type === "amount") {
      return (
        <Col sm={q.cols} key={q.name}>
          <label>
            {this.props.lang === "en" ? q.question_e : q.question_f}{" "}
          </label>
          <NumberInput
            name={q.name}
            value={q.value}
            onBlur={this.handleInputChange}
            onChange={this.handleInputChange}
            type="DECIMAL"
            precision={2}
            displaySide="left"
            displayChar="$"
          />
          <ErrorMessage>{!q.valid ? q.errorMessage : ""}</ErrorMessage>
        </Col>
      );
    }
    //value will actually hold the 'key' from the options. value will 
    //be translated on summary display and submission
    if (q.question_type === "dropdown") {
      return (
        <Col sm={q.cols} key={q.name}>
          <label>
            {this.props.lang === "en" ? q.question_e : q.question_f}
          </label>
          <Dropdownlist
            name={q.name}
            value={{ key: q.value }}
            options={this.props.lang === "en" ? q.options_e : q.options_f}
            onSelect={this.handleInputChangeDropdown}
          />
          <ErrorMessage>{!q.valid ? q.errorMessage : ""}</ErrorMessage>
        </Col>
      );
    }
    if (q.question_type === "checkboxHide") {
      return (
        <Col sm={q.cols} key={q.name}>
          <label>
            {this.props.lang === "en" ? q.question_e : q.question_f}
            {q.tooltip_e !== undefined ? (
              <Popover
                title={this.props.lang === "en" ? "Hint" : "Suggestion"}
                content={this.props.lang === "en" ? q.tooltip_e : q.tooltip_f}
              />
            ) : null}
          </label>
          <div hidden={this.props.lang === "en" ? false : true}>
            <Row>
              {q.options_e.map((option, index) => {
                return (
                  <Col sm="auto" key={index}>
                    <label>{option}</label>
                    <CheckButton
                      name={q.name + index}
                      message={""}
                      isChecked={q.value[index]}
                      onCheckedChange={this.handleInputChangeCheckboxHide}
                    />
                  </Col>
                );
              })}
            </Row>
          </div>
          <div hidden={this.props.lang === "fr" ? false : true}>
            <Row>
              {q.options_f.map((option, index) => {
                return (
                  <Col sm="auto" key={index}>
                    <label>{option}</label>
                    <CheckButton
                      name={q.name + index}
                      message={""}
                      isChecked={q.value[index]}
                      onCheckedChange={this.handleInputChangeCheckboxHide}
                    />
                  </Col>
                );
              })}
            </Row>
          </div>
        </Col>
      );
    } //single checkbox for last page declaration
    if (q.question_type === "checkbox") {
      //alert("checkbox creation")
      return (
        <Col sm={q.cols} key={q.name}>
          <label>
            {this.props.lang === "en" ? q.question_e : q.question_f}
          </label>
          <div hidden={this.props.lang === "en" ? false : true}>
            <Row>
              {q.options_e.map((option, index) => {
                return (
                  <React.Fragment key={index}>
                    <Col sm="2">
                      <CheckButton
                        name={q.name}
                        isChecked={q.value[index]}
                        message={""}
                        onCheckedChange={this.handleInputChangeCheckbox}
                      />
                    </Col>
                    <Col sm="10">{option}</Col>
                  </React.Fragment>
                );
              })}
            </Row>
          </div>
          <div hidden={this.props.lang === "fr" ? false : true}>
            <Row>
              {q.options_f.map((option, index) => {
                return (
                  <React.Fragment key={index}>
                    <Col sm="1">
                      <CheckButton
                        name={q.name}
                        isChecked={q.value[index]}
                        message={""}
                        onCheckedChange={this.handleInputChangeCheckbox}
                      />
                    </Col>
                    <Col sm="11">{option}</Col>
                  </React.Fragment>
                );
              })}
            </Row>
          </div>
        </Col>
      );
    }
    if (q.question_type === "addRemoveButtons") {
      return (
        <Col sm={q.cols} key={q.name}>
          <label>
            {this.props.lang === "en" ? q.question_e : q.question_f}
          </label>
          {this.props.currentAmount < q.max ? (
            <Button id={"Add"} onClick={this.handleInputButton}>
              {this.props.lang === "en" ? q.options_e[0] : q.options_f[0]}
            </Button>
          ) : null}
          {"   "}
          {this.props.currentAmount > q.min ? (
            <Button id={"Remove"} onClick={this.handleInputButton}>
              {this.props.lang === "en" ? q.options_e[1] : q.options_f[1]}
            </Button>
          ) : null}
        </Col>
      );
    }
  };

  createTable = () => {
    return (
      <React.Fragment>
        {this.props.layout.map((row, index) => (
          <React.Fragment key={index}>
            <Row>{row.map((col, index) => this.generateInput(col))}</Row>
          </React.Fragment>
        ))}
      </React.Fragment>
    );
  };

  render() {
    return this.createTable();
  }
}

export default GenerateInputArea;

